import templateUrl from './tax-notice-submission-list.component.html';
import { SiteModuleEnum, sortIcdCorporationByOwner } from '../../core/services/data-services';
import { sortIcdOfficeByOwner } from '../../core/services/data-services/icd-office.service';

export const TaxNoticeSubmissionListComponent = {
    templateUrl,
    controller: TaxNoticeSubmissionController,
    controllerAs: "vm",
};

function TaxNoticeSubmissionController(taxNoticeService, employeeService,
    utilityService, teamService, icdCorporationService, taxNoticeUpdateService,
    icdOfficeService) {
    'ngInject';
    const vm = this;
    vm.fileName = '';
    vm.editRowId = '';
    vm.toggle = toggle;
    vm.cancel = cancel;
    vm.open = open;
    vm.comment = comment;
    vm.displayAssign = displayAssign;
    vm.saveComment = saveComment;
    vm.assignToTeam = assignToTeam;
    vm.download = download;
    vm.isUpload = false;
    vm.isComment = false;
    vm.isStatusHistory = false;
    vm.showAssign = false;
    vm.isHub = false;
    vm.documents = [];
    vm.documentsbk = [];
    vm.allComments = [];
    vm.files;
    vm.onFileSelected = onFileSelected;
    vm.onTextChange = onTextChange;
    vm.userName;
    vm.fileName;
    vm.taxNoticeDocumentId;
    vm.commentText;
    vm.selectedId;
    vm.uploadDescription;
    vm.updatedDescription = '';
    //vm.onDescriptionChange = onDescriptionChange;
    vm.team;
    vm.onSubmit = onSubmit;
    vm.commentForm;
    vm.onChangeTeam = onChangeTeam;
    vm.isHJEE = false;
    vm.isOwner = false;
    vm.onSelectCommentFile = onSelectCommentFile;
    vm.noticeCommentFiles;
    vm.commentFileName;
    vm.downloadNoticeCommentDoc = downloadNoticeCommentDoc;
    vm.statusHistory = statusHistory;
    vm.allStatuses = [];
    vm.usrRole;
    vm.formatCorporation = formatCorporation;
    vm.close = close;
    vm.isHubAndHJEE = false;
    vm.filters;
    vm.onChangeFilters = onChangeFilters;
    vm.editID = '';
    vm.editDesc = '';
    vm.setEditNotice = setEditNotice;
    vm.clearEditNotice = clearEditNotice;

    vm.$onInit = function () {
        utilityService.showLoading();
        taxNoticeUpdateService.taxNoticeRefreshEvents$.forEach(event => {
            if (event === "update") {
                refreshData();
            }
        });
        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });

        identity
            .then((result) => {
                vm.userName = result.UserName;
                taxNoticeService.getUserRole(result.UserName)
                    .then(function (usrRole) {
                        vm.usrRole = usrRole;
                        console.log(vm.usrRole);
                        if (usrRole === "HJEE" || usrRole === "Manager") {
                            vm.isHJEE = true;
                            vm.isHubAndHJEE = true;
                            // Only retrieve for Hub and HJEE
                            icdCorporationService.retrieveIcdCorporations()
                                .then(function (icdCorporations) {
                                    icdCorporations.sort(sortIcdCorporationByOwner);
                                    vm.icdCorporations = icdCorporations;
                                    vm.icdCorporations.forEach(formatCorporationName);
                                    utilityService.hideLoading();
                                    return icdCorporations;
                                });
                            taxNoticeService.retrieveHJEEdocuments(result.UserName)
                                .then(function (result) {
                                    vm.documents = result;
                                    vm.documentsbk = result;
                                    utilityService.hideLoading();
                                    return result;
                                })

                        } else if (usrRole === "Hub") {
                            vm.isHub = true;
                            vm.isHubAndHJEE = true;
                            icdOfficeService.retrieveIcdOffices({
                                moduleID: SiteModuleEnum.Payroll
                            }).then(function (offices) {
                                offices.sort(sortIcdOfficeByOwner);
                                vm.icdCorporations = offices;
                                vm.icdCorporations.forEach(formatCorporation);
                                utilityService.hideLoading();
                            });
                            taxNoticeService.retrievedocuments(result.UserName)
                                .then(function (result) {
                                    vm.documents = result;
                                    vm.documentsbk = result;
                                    utilityService.hideLoading();
                                    return result;
                                })

                        } else {
                            vm.isOwner = true;

                            taxNoticeService.retrievedocuments(result.UserName)
                                .then(function (result) {
                                    vm.documents = result;
                                    vm.documentsbk = result;
                                    utilityService.hideLoading();
                                    return result;
                                })
                        }
                        return result;
                    })
                return result;
            })
            .catch((err) => {
                alert("Saving failed: " + utilityService.getExceptionMessage(err));
            })
    };

    function setEditNotice(noticeDocumentId: string, description: string) {
        vm.editID = noticeDocumentId;
        vm.editDesc = description;
    }

    function clearEditNotice() {
        vm.editID = '';
        vm.editDesc = '';
    }

    function formatCorporation(corporation) {
        corporation.OwnerClientName = corporation.OwnerName + " - " + corporation.IcdCorporationName
        corporation.customeId = corporation.IcdCorporationId;
        return corporation;
    }

    function formatCorporationName(corporation) {
        corporation.OwnerClientName = corporation.Owner + " - " + corporation.ClientName
        corporation.customeId = corporation.Id;
        return corporation;
    }

    function refreshData() {
        utilityService.showLoading();
        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });
        identity
            .then((result) => {
                vm.userName = result.UserName;
                taxNoticeService.getUserRole(result.UserName)
                    .then(function (usrRole) {
                        vm.usrRole = usrRole;
                        if (vm.usrRole === "HJEE" || vm.usrRole === "Manager") {
                            vm.isHJEE = true;
                            vm.isHubAndHJEE = true;
                            // Only retrieve for Hub and HJEE
                            icdCorporationService.retrieveIcdCorporations()
                                .then(function (icdCorporations) {
                                    icdCorporations.sort(sortIcdCorporationByOwner);
                                    vm.icdCorporations = icdCorporations;
                                    vm.icdCorporations.forEach(formatCorporationName);
                                    utilityService.hideLoading();
                                    return icdCorporations;
                                });

                            taxNoticeService.retrieveHJEEdocuments(vm.userName)
                                .then(function (result) {
                                    vm.documents = result;
                                    vm.documentsbk = result;
                                    utilityService.hideLoading();
                                    return result;
                                })

                        } else if (vm.usrRole === "Hub") {
                            vm.isHub = true;
                            vm.isHubAndHJEE = true;
                            // Only retrieve for Hub and HJEE
                            icdOfficeService.retrieveIcdOffices({
                                moduleID: SiteModuleEnum.Payroll
                            }).then(function (offices) {
                                offices.sort(sortIcdOfficeByOwner);
                                vm.icdCorporations = offices;
                                vm.icdCorporations.forEach(formatCorporation);
                                utilityService.hideLoading();
                            });

                            taxNoticeService.retrievedocuments(vm.userName)
                                .then(function (result) {
                                    vm.documents = result;
                                    vm.documentsbk = result;
                                    utilityService.hideLoading();
                                    return result;
                                })

                        } else {
                            taxNoticeService.retrievedocuments(vm.userName)
                                .then(function (result) {
                                    vm.documents = result;
                                    vm.documentsbk = result;
                                    utilityService.hideLoading();
                                    return result;
                                })
                        }
                    })
            });
    }

    function toggle(document: any, description: string) {
        if (document.Description !== description) {
            utilityService.showLoading();
            taxNoticeService.updateDescription({
                TaxNoticeDocumentId: document.NoticeDocumentId,
                Text: description
            }).then(function (result) {
                vm.editID = '';
                vm.editDesc = '';
                const edited = vm.documents.find(x => x.NoticeDocumentId === document.NoticeDocumentId);
                edited.Description = description;
                vm.documents.splice(vm.documents.indexOf(document), 1, edited);
                utilityService.hideLoading();
            }).catch(function (ex) {
                utilityService.hideLoading();
            });
        } else {
            vm.editID = '';
            vm.editDesc = '';
        }
    }

    function cancel() {
        if (confirm('Are you sure to Cancel?') === true) {
            vm.files = '';
            vm.uploadDescription = '';
            vm.icdCorporations = [];
            vm.name = '';
            vm.isUpload = false;
            vm.showAssign = false;
            vm.isStatusHistory = false;
            vm.isComment = false;
            vm.commentText = '';
            vm.commentFileName = '';
            vm.noticeCommentFiles = '';
        }
    }

    function close() {
        vm.isUpload = false;
        vm.showAssign = false;
        vm.isStatusHistory = false;
        vm.isComment = false;
    }

    function open() {
        vm.isUpload = true;
        taxNoticeUpdateService.refreshTaxNotice('update');
    }

    function onChangeFilters() {
        console.log(vm.filters.noticeNumber);
        vm.filterDocs = vm.documentsbk;
        console.log(vm.filterDocs);
        if (vm.filters.clientName) {
            vm.filterDocs = vm.filterDocs.filter(x => x.CompanyName.toLowerCase()
                .includes(vm.filters.clientName.toLowerCase()));
        }
        if (vm.filters.owner) {
            vm.filterDocs = vm.filterDocs.filter(x => x.OwnerName.toLowerCase()
                .includes(vm.filters.owner.toLowerCase()));
        }
        if (vm.filters.noticeNumber) {
            vm.filterDocs = vm.filterDocs.filter(x => String(x.RequestNumber) === String(vm.filters.noticeNumber));
        }
        if (vm.filters.uploadFrom) {
            vm.filterDocs = vm.filterDocs.filter(x => new Date(x.CreatedOn) >= vm.filters.uploadFrom);
        }
        if (vm.filters.uploadTo) {
            vm.filterDocs = vm.filterDocs.filter(x => new Date(x.CreatedOn) <= vm.filters.uploadTo);
        }
        console.log(vm.filterDocs);
        vm.documents = vm.filterDocs;
    }

    function displayAssign(noticeDocumentId: any) {
        utilityService.showLoading();
        vm.taxNoticeDocumentId = noticeDocumentId;

        teamService.retrieveTeams()
            .then(function (teams) {
                vm.names = teams
                utilityService.hideLoading();
            });
        vm.showAssign = true;
    }

    function comment(noticeDocumentId: any, fileNames: any, currentStatus: any) {
        utilityService.showLoading();
        vm.isComment = true;
        vm.taxNoticeDocumentId = noticeDocumentId;
        vm.fileName = fileNames;
        vm.currentStatus = currentStatus;

        taxNoticeService.retrieveComments(vm.taxNoticeDocumentId)
            .then(function (result) {
                vm.allComments[0] = result;
                utilityService.hideLoading();
                return result;
            })
            .catch((err) => {
                utilityService.hideLoading();
                alert("Comment: " + utilityService.getExceptionMessage(err));
            })
    }

    function statusHistory(requestId: any) {
        utilityService.showLoading();
        vm.isStatusHistory = true;
        vm.requestId = requestId;

        taxNoticeService.retrieveStatusHistory(vm.requestId)
            .then(function (result) {
                console.log(result);
                vm.allStatuses[0] = result;
                utilityService.hideLoading();
                return result;
            }).catch((err) => {
                utilityService.hideLoading();
                alert("StatusHistory: " + utilityService.getExceptionMessage(err));
            })
    }

    function onFileSelected() {
        // const file = vm.files;
    }

    function onTextChange() {
        //const text = vm.commentText;
    }

    function onChangeTeam() {
        // alert(vm.name.TeamID);
    }

    function onSelectCommentFile() {
        vm.commentFileName = vm.noticeCommentFiles.name;
    }

    function downloadNoticeCommentDoc(commentId: any) {
        utilityService.showLoading();
        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });
        identity
            .then((identity) => {
                taxNoticeService.downloadNoticeCommentDocument({
                    CommentId: commentId,
                    TaxNoticeDocumentId: 'N/A',
                    UserName: identity.UserName,
                    Text: 'downloading comment file',
                    TeamId: 'N/A',
                    TeamMemberEmpId: 'TeamMember'
                }).then(function (isDownloaded) {
                    utilityService.hideLoading();
                    return isDownloaded;
                })
                    .catch(function (ex) {
                        utilityService.hideLoading();
                        alert("Downloading failed: " + utilityService.getExceptionMessage(ex));
                    })
            })
            .catch((err) => {
                utilityService.hideLoading();
                alert("Downloading failed: " + utilityService.getExceptionMessage(err));
            })
    }

    function onSubmit() {
        utilityService.showLoading();
        const files = vm.files;
        const description = vm.uploadDescription;
        let id = '';
        if (files) {
            const identity = employeeService.retrieveIdentity()
                .then(function (identity) {
                    return identity;
                });
            identity
                .then((identity) => {
                    vm.userName = identity.UserName;
                    if (vm.icdCorporation !== undefined) {
                        id = vm.icdCorporation.customeId;
                    }
                    taxNoticeService.uploaddocument(identity.UserName,
                        { Files: files, Description: description, IcdCorporationId: id })
                        .then(function (isUploaded) {
                            utilityService.hideLoading();
                            if (isUploaded === true) {
                                vm.files = '';
                                vm.uploadDescription = '';
                                vm.icdCorporations = [];
                                taxNoticeUpdateService.refreshTaxNotice('update');
                                vm.isUpload = false;
                            }
                            utilityService.hideLoading();
                            return isUploaded;
                        })
                        .catch(function (ex) {
                            alert("Saving failed: " + utilityService.getExceptionMessage(ex));
                        })
                    return identity;
                })
                .catch((err) => {
                    utilityService.hideLoading();
                    alert("Saving failed: " + utilityService.getExceptionMessage(err));
                })
        }
    }

    function saveComment() {
        utilityService.showLoading();
        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });

        identity
            .then((identity) => {
                vm.userName = identity.UserName;
                taxNoticeService.saveComment({
                    TaxNoticeDocumentId: vm.taxNoticeDocumentId,
                    UserName: identity.UserName,
                    Text: vm.commentText,
                    TeamId: 'N/A',
                    TeamMemberEmpId: 'TeamMember',
                    Files: vm.noticeCommentFiles
                }).then(function (isSaved) {
                    if (isSaved === true) {
                        taxNoticeService.retrieveComments(vm.taxNoticeDocumentId)
                            .then(function (comments) {
                                vm.commentText = '';
                                vm.commentFileName = '';
                                vm.noticeCommentFiles = undefined;
                                vm.allComments[0] = comments;
                                utilityService.hideLoading();
                            })
                            .catch((err) => {
                                utilityService.hideLoading();
                                alert("Saving Comment failed: " + utilityService.getExceptionMessage(err));
                            })
                    } else {
                        utilityService.hideLoading();
                        alert("Saving Comment failed: ");
                    }
                    return isSaved;
                })
                    .catch((err) => {
                        utilityService.hideLoading();
                        alert("Saving Comment failed: " + utilityService.getExceptionMessage(err));
                    })
            })
    }

    function assignToTeam() {
        utilityService.showLoading();
        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });
        identity
            .then((result) => {
                vm.userName = result.UserName;
                taxNoticeService.assignToTeamDocument({
                    TaxNoticeDocumentId: vm.taxNoticeDocumentId,
                    UserName: result.UserName,
                    Text: 'Assigning Notice To Team',
                    TeamId: vm.name.TeamID,
                    TeamMemberEmpId: 'TeamMember'
                })
                    .then(function (assigned) {
                        if (assigned === true) {
                            utilityService.hideLoading();
                            vm.name = '';
                            vm.showAssign = false;
                            taxNoticeUpdateService.refreshTaxNotice('update');
                        }
                    })
                    .catch(function (ex) {
                        utilityService.hideLoading();
                        alert("Assign failed: " + utilityService.getExceptionMessage(ex));
                    })
                return result;
            })
            .catch((err) => {
                utilityService.hideLoading();
                alert("Assign failed: " + utilityService.getExceptionMessage(err));
            })
    }

    function download(taxNoticeDocumentId: any) {
        utilityService.showLoading();

        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });
        identity
            .then((result) => {
                vm.userName = result.UserName;
                taxNoticeService.downloadDocument({
                    TaxNoticeDocumentId: taxNoticeDocumentId,
                    UserName: result.UserName,
                    Text: 'downloading file',
                    TeamId: 'N/A',
                    TeamMemberEmpId: 'TeamMember'
                }).then(function (result) {
                    utilityService.hideLoading();
                    if (result === true) {
                        utilityService.hideLoading();
                        if (result === true) {
                            utilityService.hideLoading();
                            return result;
                        }
                    }
                }).catch(function (ex) {
                    utilityService.hideLoading();
                    alert("Download failed: " + utilityService.getExceptionMessage(ex));
                })
                return result;
            })
            .catch((err) => {
                utilityService.hideLoading();
                alert("Download failed: " + utilityService.getExceptionMessage(err));
            })
    }
}
